import React from 'react';
import QuizStore from './../../stores/QuizStore.js';
import QuizActionCreators from './../../actions/QuizActionCreators.js';
import cx from '../../utils/cx.js';

class Quiz extends React.Component {
	static defaultProps = {
	  question: [],
	  next_question: [],
	  quiz: [],
	  score: 0,
	  loadingImages: true,
	};

	render() {
	  const question = this.props.question;
	  const next_question = this.props.next_question;
	  const quiz = this.props.quiz;
	  const self = this;

	  const preloadImages = function () {
	    const images = [];

	    if (typeof next_question.answers === 'undefined' || next_question.answers.length < 1) {
	      return ('');
	    }

	    if (next_question.type == 'img' || next_question.type == 'gif') {
	      for (const index in next_question.answers) {
	        images.push(<img src={next_question.answers[index].img_src} />);
	      }
	      return (
  <div style={{
 visibility: 'hidden', width: 0, height: 0, overflow: 'hidden',
}}>
    {images}
  </div>
	      );
	    }

	    return ('');
	  };

	  const getAnswers = function () {
	    const answers = [];
	    let answersClassName = 'quiz-question-answers';
	    const letters = ['A: ', 'B: ', 'C: '];

	    if (typeof question.answers === 'undefined' || question.answers.length < 1) {
	      return ('');
	    }

	    for (const index in question.answers) {
	      if (question.type == 'text') {
	        answers.push(<div
  className="quiz-answer quiz-answer-text"
  onClick={self.handleClick.bind(this, question.answers[index]._id, question._id, question.answers[index].result)}
	        >
  {letters[index] + question.answers[index].title}
                      </div>);
	      }

	      if (question.type == 'img' || question.type == 'gif') {
	        answers.push(<div
  className="quiz-answer quiz-answer-img"
  onClick={self.handleClick.bind(this, question.answers[index]._id, question._id, question.answers[index].result)}
	        >
  <div className="quiz-answer-img-wrap pr">
    <img onLoad={e => self.handleImageLoaded(e)} src={question.answers[index].img_src} width="100%" height="auto" />
  </div>
                      </div>);
	      }
	    }

	    if (question.type == 'img' || question.type == 'gif') {
	      answers.push(<div style={{ clear: 'both' }} />);
	      answersClassName += ' quiz-question-answers-img';
	    }

	    return (
  <div className={answersClassName}>
    {answers}
  </div>
	    );
	  };

	  return (
  <div className="quiz">
    <div className="quiz-header">
      <div className="quiz-header-title">{quiz.header_title}</div>
      <div className="quiz-header-sub_title">{quiz.header_sub_title}</div>
      <div className="quiz-header-logo quiz-header-logo--durex" />
    </div>
    <div className={cx(['quiz-question', ['loading', self.props.loadingImages]])}>
      <div className="quiz-question-title">
        {question.title}
      </div>
      {getAnswers()}
    </div>
    <div
      className="questionBlock-meter tooltip"
      data-tooltip={`${op.messages.question}: ${self.props.active_question}/${self.props.question_count}`}
    >
      <div style={{ width: `${self.props.score}%` }} className="questionBlock-meter-inner" />
    </div>
    {preloadImages()}
  </div>
	  );
	}

	handleClick = (answer_id, question_id, result, e) => {
	  e.preventDefault();
	  QuizActionCreators.saveAnswer(answer_id, question_id, result);
	};

	handleImageLoaded = (e) => {
	  this.props.imageLoaded();
	};
}

module.exports = Quiz;
